import { render, staticRenderFns } from "./formConfig.vue?vue&type=template&id=5489eddf&scoped=true&"
import script from "./formConfig.vue?vue&type=script&lang=js&"
export * from "./formConfig.vue?vue&type=script&lang=js&"
import style0 from "./formConfig.vue?vue&type=style&index=0&id=5489eddf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489eddf",
  null
  
)

export default component.exports